import React from 'react';
import Navbar from '../components/Navbar';
import HistoricoRegistros from '../components/HistoricoComponents/HistoricoRegistros';

const HistoricoRegistrosPage = () => {
  return (
    <div className="min-h-screen bg-blanco-nieve text-gris-oscuro">
      <Navbar />
      <div >
        <HistoricoRegistros />
      </div>
    </div>
  );
};

export default HistoricoRegistrosPage;